export const DEFAULT_TEAMS_PAGE_SIDE_BAR_CONTEXT_DATA = {
    registerCallback: () => {},
    callBackMap: {},
};

export const MEETING_BOOKED_COUNT_REFRESH_CALLBACK = 'onMeetingsBookedChange';
